// import React from "react";
// import { ReactTyped } from "react-typed";
// import ProfileImg from "./Assests/ProfileImg";

// const Hero = () => {
//   return (
//     <div className="text-white max-w-[800px] mt-[-96px] w-full h-screen mx-auto text-left flex flex-col justify-center ">
//       <div className="p-2">
//         <h1 className="">Hello, I'm</h1>
//         <h1 className="text-[#00df9a] md:text-7xl sm:text-6xl text-4xl font-bold ">
//           Keerthi
//         </h1>
//         <h2 className="text-white md:text-6xl sm:text-5xl text-3xl font-bold ">
//           Vemula Murali
//         </h2>
//       </div>
//       <div className="flex p-2 text-xl">
//         {/* <p>Software</p> */}
//         <ReactTyped className='pl-2' strings={['Data Scientist', 'Software Developer']} typeSpeed={120} backSpeed={120} loop/>
//       </div>
//       <div className="ml-[450px] sm:pt-[10px] absolute">
//         <ProfileImg/>
//       </div>
//       <div className="flex p-2 text-xl">
//         <a
//           href="/resume.pdf"
//           download
//           className="px-6 py-3 bg-black text-[#00df9a] font-semibold rounded-2xl shadow-lg hover:bg-[#00b87a] transition duration-300"
//         >
//           Download Resume
//         </a>
//       </div>

//     </div>
//   );
// };

// export default Hero;


import React from "react";
import { ReactTyped } from "react-typed";
import ProfileImg from "./Assests/ProfileImg";

const Hero = () => {
  return (
    <div className="text-white w-full flex items-center justify-center px-4 py-16">
      <div className="max-w-6xl mx-auto w-full mt-16">
        {/* Flex container: side by side on md+ screens */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-6">
          
          {/* Left: Intro Text - Order changed for better mobile experience */}
          <div className="text-center md:text-left order-2 md:order-1 flex-1">
            <h1 className="text-lg sm:text-xl text-gray-300 mb-2">Hello, I'm</h1>
            <h1 className="text-[#00df9a] font-bold text-4xl sm:text-6xl md:text-7xl">
              Keerthi
            </h1>
            <h2 className="text-white font-bold text-3xl sm:text-5xl md:text-6xl mb-4">
              Vemula Murali
            </h2>

            {/* Typing Effect */}
            <div className="text-xl sm:text-2xl md:text-3xl mt-6 mb-8 min-h-[2.5rem]">
              <ReactTyped
                // className="text-gray-300"
                className='pl-2'
                strings={["Data Scientist", "Software Developer", "AI Enthusiast"]}
                typeSpeed={120}
                backSpeed={120}
                loop
              />
            </div>

            {/* Resume Button */}
            {/* <div className="mt-6">
              <a
                href="/resume_new.pdf"
                download
                className="inline-block px-4 py-3 bg-[#00df9a] text-black font-semibold rounded-full shadow-lg hover:bg-[#00b87a] hover:scale-105 transition-all duration-300"
              >
                Download Resume
              </a>
            </div> */}


              <div className="flex justify-center gap-4 mt-4">
              <a
                href="/KeerthiVemulaMurali_Resume_ALL.pdf"
                download
                className="inline-block px-4 py-3 bg-[#00df9a] text-black font-semibold rounded-full shadow-lg hover:bg-[#00b87a] hover:scale-105 transition-all duration-300"
              >
                Download CV
              </a>
              <a
                href="/Transcript.pdf"
                download
                className="inline-block px-2 py-3 bg-[#00df9a] text-black font-semibold rounded-full shadow-lg hover:bg-[#00b87a] hover:scale-105 transition-all duration-300"
              >
                Download Transcript
              </a>
            </div>


          </div>

          {/* Right: Profile Image */}
          {/* <div className="order-1 md:order-2 flex-shrink-0 w-48 h-48 sm:w-56 sm:h-56 md:w-72 md:h-72 relative"> */}
          <div className="order-1 md:order-2 flex-shrink-0 w-48 h-48 sm:w-56 sm:h-56 md:w-72 md:h-72 relative">
            <div className="w-full h-full rounded-full bg-gradient-to-br from-[#00df9a] to-teal-700 p-1 shadow-xl">
              <div className="w-full h-full rounded-full bg-gray-800 flex items-center justify-center overflow-hidden border-4 border-gray-800">
                <ProfileImg />
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#00df9a] opacity-70"></div>
            <div className="absolute -bottom-2 -left-2 w-8 h-8 rounded-full bg-[#00df9a] opacity-50"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;

